module.exports = __webpack_public_path__ + "img/amm-smart-contract.a139f9b3.png";